module.exports = __webpack_public_path__ + "static/media/watermelon.eb96fea8.svg";